<template>
  <div class="err403">
    <div class="art" aria-hidden="true">
      <!-- 简洁的锁图形，带轻微呼吸动画 -->
      <svg class="lock" viewBox="0 0 128 128" width="140" height="140">
        <defs>
          <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-opacity="1"/>
            <stop offset="1" stop-opacity="0.85"/>
          </linearGradient>
        </defs>
        <rect x="24" y="58" width="80" height="58" rx="10" fill="url(#g)"/>
        <path d="M40,58 v-14 a24,24 0 0 1 48,0 v14" fill="none" stroke="currentColor" stroke-width="8" stroke-linecap="round"/>
        <circle class="keyhole" cx="64" cy="88" r="7" fill="currentColor"/>
      </svg>

      <div class="code">403</div>
    </div>

    <h1>没有权限访问</h1>
    <p class="desc">
      抱歉，你没有权限访问该页面。请联系管理员为你的账号开通相应权限。
    </p>
    <p v-if="from" class="from">
      尝试访问：<code>{{ from }}</code>
    </p>

    <div class="actions">
      <el-button type="primary" @click="goHome">返回首页</el-button>
      <el-button @click="goBack">返回上一页</el-button>
      <el-button type="text" @click="refresh">刷新</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error403',
  computed: {
    from() {
      // 若守卫里带了 ?from=xxx，可在这里展示
      return this.$route && this.$route.query && this.$route.query.from
        ? decodeURIComponent(this.$route.query.from)
        : '';
    }
  },
  methods: {
    goHome() {
      this.$router.replace({ path: '/' });
    },
    goBack() {
      // 若没有历史记录则回首页
      if (window.history.length > 1) this.$router.back();
      else this.goHome();
    },
    refresh() {
      window.location.reload();
    }
  }
}
</script>

<style lang="scss" scoped>
.err403 {
  --fg: #1f2d3d;        // 文字主色（亮模式）
  --sub: #5c6b77;       // 次要文字
  --card: #ffffff;      // 卡片背景
  --grad-a: #6aa0ff;    // 渐变 A
  --grad-b: #6fe4c2;    // 渐变 B
  --shadow: 0 10px 30px rgba(0,0,0,.08);

  min-height: calc(100vh - 120px);
  padding: 6vh 24px 24px;
  display: grid;
  place-items: center;
  color: var(--fg);

  .art {
    position: relative;
    display: grid;
    place-items: center;
    width: 320px;
    height: 220px;
    margin-bottom: 12px;
    background: var(--card);
    border-radius: 20px;
    box-shadow: var(--shadow);
  }

  .lock {
    color: var(--fg);
    opacity: .9;
    animation: breathe 2.8s ease-in-out infinite;
    /* 用渐变蒙版让锁更有层次 */
    & rect { fill: linear-gradient(135deg, var(--grad-a), var(--grad-b)); }
  }

  .code {
    position: absolute;
    inset: auto 0 12px 0;
    text-align: center;
    font-size: 56px;
    font-weight: 800;
    letter-spacing: 2px;
    background: linear-gradient(135deg, var(--grad-a), var(--grad-b));
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    user-select: none;
  }

  h1 {
    margin: 6px 0 8px;
    font-size: 22px;
    font-weight: 700;
    text-align: center;
  }

  .desc, .from {
    margin: 2px 0;
    max-width: 640px;
    text-align: center;
    color: var(--sub);
    code {
      padding: 2px 6px;
      border-radius: 6px;
      background: rgba(0,0,0,.05);
      word-break: break-all;
    }
  }

  .actions {
    margin-top: 14px;
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
  }
}

/* 暗黑模式适配 */
@media (prefers-color-scheme: dark) {
  .err403 {
    --fg: #e8eef4;
    --sub: #b8c2cc;
    --card: #1f2937;
    --grad-a: #7aa2ff;
    --grad-b: #69e0c8;
    --shadow: 0 10px 30px rgba(0,0,0,.35);
    .desc code, .from code { background: rgba(255,255,255,.08); }
  }
}

@keyframes breathe {
  0%, 100% { transform: translateY(0) scale(1);   opacity: .95; }
  50%      { transform: translateY(-2px) scale(1.02); opacity: 1; }
}

/* 更窄屏幕的排版优化 */
@media (max-width: 420px) {
  .err403 {
    padding-top: 4vh;
    .art { width: 86vw; height: 200px; }
    .code { font-size: 44px; }
  }
}
</style>
